export default "__VITE_ASSET__C6C1s$SB__"